import React from 'react';

import { Grid, Segmented, Typography } from 'antd';

const { useBreakpoint } = Grid;

interface IRadioSelectionProps {
  formLabel: string;
  options: {
    value: string;
    label: React.ReactNode;
  }[];
  selectedValue: string;
  handleSelected: (value: string) => void;
  isDisabled: boolean;
}

function RadioSelection({ formLabel, options, selectedValue, handleSelected, isDisabled }: IRadioSelectionProps) {
  const screens = useBreakpoint();

  return (
    <div className='flex flex-col gap-3'>
      {!!formLabel && <Typography.Text type='secondary'>{formLabel}</Typography.Text>}
      <Segmented
        className={
          'w-fit [--uizz-antd-segmented-item-selected-bg:var(--uizz-antd-color-primary)] [--uizz-antd-segmented-item-selected-color:var(--uizz-antd-color-text-light-solid)]'
        }
        vertical={!screens.sm}
        value={selectedValue}
        onChange={handleSelected}
        disabled={isDisabled}
        options={options}
      />
    </div>
  );
}

export default RadioSelection;
